import {
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import LoginForm from "./components/LoginForm";
import { grey } from "@mui/material/colors";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import { styled } from "@mui/material";
import { Stack } from "@mui/material";
import AuthPage from "../../Components/AuthPage";

const ForgotPassword = () => {
  const [show, setShow] = useState(false);

  const handleModal = () => {
    setShow(!show);
  };

  return (
    <AuthPage title="Login">
      <Dialog open={show} onClose={handleModal}>
        <DialogTitle sx={{ background: grey[200] }}>
          <Typography variant="h6" align="left">
            Forgot password
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ m: "20px" }}>
          <ForgotPasswordForm handleModal={handleModal} />
        </DialogContent>
      </Dialog>

      <Box
        sx={{
          // height: "auto",
          py: 4,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <ForgotPasswordForm />
      </Box>
    </AuthPage>
  );
};

export default ForgotPassword;
